import { ReactElement, ReactNode } from 'react';

import SignalRSOS from '~/ui/pages/Notifications/components/SignalRSOS';

import useRole from '~/store/user/hooks/useRole';
import { useSignalRToken } from './SignalRTokenProvider';

interface IProps {
  children: ReactNode | ReactNode[];
}

const PanicRequestsProvider = ({ children }: IProps): ReactElement => {
  const { token, isOnline, handleError, handleConnection } = useSignalRToken();
  const { isSuperAdmin, isProductOwner } = useRole();

  const isConnectionDisabled = isSuperAdmin || isProductOwner;
  const isConnected = !!token && !isConnectionDisabled && isOnline;

  const connectionCloseDelay = () =>
    new Promise<void>(resolve => {
      setTimeout(() => {
        resolve();
      }, 1000);
    });

  return (
    <SignalRSOS.SignalRContext.Provider
      connectEnabled={isConnected}
      withCredentials={false}
      dependencies={[token]}
      transport={1}
      skipNegotiation
      url={process.env.REACT_APP_API_URL.replace(
        'api/v1/',
        `hubs/panic-request?access_token=${token}`,
      )}
      logger={6}
      onBeforeClose={connectionCloseDelay}
      onOpen={handleConnection}
      onReconnect={handleConnection}
      onError={handleError}
    >
      {children}
    </SignalRSOS.SignalRContext.Provider>
  );
};
export default PanicRequestsProvider;
